import "@/lib/fonts";
import "@/styles/globals.css";
import { SITE } from "@/data/site";
import Noise from "@/components/shared/Noise";
import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import TransitionProvider from "@/components/layout/TransitionProvider";
import HelpIcon from "@/components/shared/HelpIcon";
import TomorrowFooter from "@/components/tomorrow/TomorrowFooter";
import { usePageContext } from "vike-react/usePageContext";

/** A page asks for a footer other than the site's through its data (the store collection route
 *  sets `footer: "tomorrow-co"` on Tomorrow Co's page). Every other page gets the site footer. */
type FooterData = { footer?: string; collection?: { name?: string } } | undefined;

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
  const data = usePageContext().data as FooterData;
  return (
    <div data-app="oddstack">
      <Noise />
      <Nav />
      <TransitionProvider>{children}</TransitionProvider>
      {data?.footer === "tomorrow-co" ? <TomorrowFooter name={data.collection?.name ?? "Tomorrow Co"} /> : <Footer />}
      <HelpIcon />
    </div>
  );
}
